/**
 * Shared formatting for tester pool requirements in MCP tool responses.
 */

import type { JobStatusResponse } from '@runhuman/shared';
import { DEVICE_CAPABILITY, LANGUAGE_CAPABILITY, SOCIAL_VIDEOS_CAPABILITY, SIDELOAD_INSTALL_CAPABILITY } from '@runhuman/shared';

/**
 * Formats tester pool fields from a job response into display text.
 * Returns empty string if no tester pool requirements are set.
 */
export function formatTesterPool(job: Pick<JobStatusResponse, 'deviceClass' | 'requiredDevices' | 'requiredLanguages' | 'requireSocialVideos' | 'requireSideload'>): string {
  const lines: string[] = [];

  if (job.deviceClass) {
    lines.push(`Device Class: ${job.deviceClass}`);
  }
  if (job.requiredDevices?.length) {
    const labels = job.requiredDevices.map(d => DEVICE_CAPABILITY.labels[d]);
    lines.push(`Required Devices: ${labels.join(', ')}`);
  }
  if (job.requiredLanguages?.length) {
    const labels = job.requiredLanguages.map(l => LANGUAGE_CAPABILITY.labels[l]);
    lines.push(`Required Languages: ${labels.join(', ')}`);
  }
  if (job.requireSocialVideos) {
    lines.push(`${SOCIAL_VIDEOS_CAPABILITY.slackLabel}: required`);
  }
  if (job.requireSideload) {
    lines.push(`${SIDELOAD_INSTALL_CAPABILITY.slackLabel}: required`);
  }

  return lines.length > 0 ? '\n' + lines.join('\n') : '';
}
